import { COMMUNICATION } from '../../../../api/pushVisit';

const RxWhatsApp: React.FC<{
    pushStatus: 'loading' | 'error' | 'success' | 'offline' | undefined;
    onPhoneChange: () => void;
    phoneNumber: string;
    communication: COMMUNICATION | undefined;
}> = ({ pushStatus, onPhoneChange, phoneNumber, communication }) => {
    return (
        <div className="flex items-center justify-between">
            <div className="flex items-center space-x-16">
                {pushStatus === 'loading' || communication === COMMUNICATION.NOT_APPLICABLE ? (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 448 512"
                        className="fill-neutral-5 relative top-2 mr-4 cursor-pointer"
                    >
                        <path d="M32 0C14.3 0 0 14.3 0 32V192v96c0 17.7 14.3 32 32 32s32-14.3 32-32V224h50.7l128 128L137.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 397.3 393.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L333.3 352 438.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 306.7l-85.8-85.8C251.4 209.1 288 164.8 288 112C288 50.1 237.9 0 176 0H32zM176 160H64V64H176c26.5 0 48 21.5 48 48s-21.5 48-48 48z" />
                    </svg>
                ) : (
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 28 28"
                        className="fill-neutral-5 relative top-2 mr-4 cursor-pointer"
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2M12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15C10.56 20.15 9.11 19.76 7.85 19L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 15 3.8 13.47 3.8 11.91C3.81 7.37 7.5 3.67 12.05 3.67M8.53 7.33C8.37 7.33 8.1 7.39 7.87 7.64C7.65 7.89 7 8.5 7 9.71C7 10.93 7.89 12.1 8 12.27C8.14 12.44 9.76 14.94 12.25 16C12.84 16.27 13.3 16.42 13.66 16.53C14.25 16.72 14.79 16.69 15.22 16.63C15.7 16.56 16.68 16.03 16.89 15.45C17.1 14.87 17.1 14.38 17.04 14.27C16.97 14.17 16.81 14.11 16.56 14C16.31 13.86 15.09 13.26 14.87 13.18C14.64 13.1 14.5 13.06 14.31 13.3C14.15 13.55 13.67 14.11 13.53 14.27C13.38 14.44 13.24 14.46 13 14.34C12.74 14.21 11.94 13.95 11 13.11C10.26 12.45 9.77 11.64 9.62 11.39C9.5 11.15 9.61 11 9.73 10.89C9.84 10.78 10 10.6 10.1 10.45C10.23 10.31 10.27 10.2 10.35 10.04C10.43 9.87 10.39 9.73 10.33 9.61C10.27 9.5 9.77 8.26 9.56 7.77C9.36 7.29 9.16 7.35 9 7.34C8.86 7.34 8.7 7.33 8.53 7.33Z"></path>
                    </svg>
                )}
                <div>
                    <WhatsAppAndSmsSendToMessage
                        pushStatus={pushStatus}
                        onPhoneChange={onPhoneChange}
                        phoneNumber={phoneNumber}
                        communication={communication}
                    />

                    <WhatsAppMessageStatusMessage
                        pushStatus={pushStatus}
                        communication={communication}
                    />
                </div>
            </div>
            <WhatsAppMessageStatusIcon pushStatus={pushStatus} communication={communication} />
        </div>
    );
};

const WhatsAppMessageStatusIcon: React.FC<{
    pushStatus: 'loading' | 'error' | 'success' | 'offline' | undefined;
    communication?: COMMUNICATION;
}> = ({ pushStatus, communication }) => {
    return (
        <>
            {pushStatus === 'error' && (
                <svg
                    width="25"
                    height="25"
                    viewBox="0 0 28 28"
                    className="fill-status-warning cursor-pointer fill-status-warning"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <path d="M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z"></path>
                </svg>
            )}
            {pushStatus === 'offline' && (
                <svg
                    width="25"
                    height="25"
                    viewBox="0 0 28 28"
                    className="fill-status-error cursor-pointer fill-status-error"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <path d="M2.28,3L1,4.27L2.47,5.74C2.04,6 1.61,6.29 1.2,6.6L3,9C3.53,8.6 4.08,8.25 4.66,7.93L6.89,10.16C6.15,10.5 5.44,10.91 4.8,11.4L6.6,13.8C7.38,13.22 8.26,12.77 9.2,12.47L11.75,15C10.5,15.07 9.34,15.5 8.4,16.2L12,21L14.46,17.73L17.74,21L19,19.72M12,3C9.85,3 7.8,3.38 5.9,4.07L8.29,6.47C9.5,6.16 10.72,6 12,6C15.38,6 18.5,7.11 21,9L22.8,6.6C19.79,4.34 16.06,3 12,3M12,9C11.62,9 11.25,9 10.88,9.05L14.07,12.25C15.29,12.53 16.43,13.07 17.4,13.8L19.2,11.4C17.2,9.89 14.7,9 12,9Z"></path>
                </svg>
            )}
            {pushStatus === 'success' && (
                <>
                    {(communication === COMMUNICATION.SENT ||
                        communication === COMMUNICATION.NOT_APPLICABLE) && (
                        <svg
                            width="25"
                            height="25"
                            viewBox="0 0 28 28"
                            className="fill-actionSecondary cursor-pointer fill-actionSecondary"
                            preserveAspectRatio="xMidYMid meet"
                        >
                            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"></path>
                        </svg>
                    )}{' '}
                    {communication === COMMUNICATION.ERROR && (
                        <svg
                            width="25"
                            height="25"
                            className="fill-status-warning cursor-pointer fill-status-warning"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path d="M448 0H64C28.75 0 0 28.75 0 63.1v287.1c0 35.25 28.75 63.1 64 63.1h96v83.1c0 9.75 11.25 15.45 19.12 9.7L304 415.1H448c35.25 0 64-28.75 64-63.1V63.1C512 28.75 483.3 0 448 0zM336.1 255c9.375 9.375 9.375 24.56 0 33.94c-9.383 9.379-24.56 9.371-33.94 0L256 241.9L208.1 288.1c-9.383 9.379-24.56 9.371-33.94 0c-9.375-9.375-9.375-24.56 0-33.94L222.1 208L175 160.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 174.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94L289.9 208L336.1 255z" />
                        </svg>
                    )}
                </>
            )}
            {pushStatus === 'loading' && (
                <div className="w-32 h-32">
                    <svg className="circular-loader" viewBox="25 25 50 50">
                        <circle
                            className="loader-path"
                            cx="50"
                            cy="50"
                            r="20"
                            fill="none"
                            stroke="#000000"
                            stroke-width="3"
                        ></circle>
                    </svg>
                </div>
            )}
        </>
    );
};

const WhatsAppMessageStatusMessage: React.FC<{
    pushStatus: 'loading' | 'error' | 'success' | 'offline' | undefined;
    communication?: COMMUNICATION;
}> = ({ pushStatus, communication }) => {
    return (
        <>
            {pushStatus === 'success' && (
                <>
                    {communication === COMMUNICATION.SENT && (
                        <p className="uppercase text-actionSecondary font-600">SUCCESS</p>
                    )}
                    {(communication === COMMUNICATION.ERROR ||
                        communication === COMMUNICATION.OFF) && (
                        <p className="uppercase text-status-warning font-600">NO MESSAGE SENT</p>
                    )}
                </>
            )}
            {pushStatus === 'error' && (
                <p className="uppercase text-status-warning font-600">ERROR</p>
            )}
            {pushStatus === 'offline' && (
                <p className="uppercase text-status-error font-600">OFFLINE</p>
            )}
        </>
    );
};

const WhatsAppAndSmsSendToMessage: React.FC<{
    pushStatus: 'loading' | 'error' | 'success' | 'offline' | undefined;
    onPhoneChange: () => void;
    phoneNumber: string;
    communication: COMMUNICATION | undefined;
}> = ({ pushStatus, onPhoneChange, phoneNumber, communication }) => {
    if (pushStatus === 'loading') {
        return <p>Generating Prescription...</p>;
    }

    return (
        <p>
            {communication === COMMUNICATION.OFF ||
            communication === COMMUNICATION.LATER ||
            communication === COMMUNICATION.NOT_APPLICABLE ? (
                <span>Prescription Saved Successfully. </span>
            ) : (
                'WhatsApp & SMS Sent to '
            )}
            {communication !== COMMUNICATION.NOT_APPLICABLE && (
                <span
                    onClick={pushStatus === 'success' ? onPhoneChange : undefined}
                    className="whitespace-nowrap"
                >
                    {
                        <div
                            className={`inline border-b border-transparent cursor-pointer ${
                                pushStatus === 'success'
                                    ? 'text-actionPrimary hover:border-actionPrimary-hover hover:text-actionPrimary-hover'
                                    : ''
                            }`}
                        >
                            <span>{phoneNumber}</span>
                        </div>
                    }
                    {pushStatus === 'success' && (
                        <div className="inline-flex items-end justify-center w-16 h-20 ml-4">
                            <svg
                                viewBox="0 0 24 24"
                                width="16"
                                height="16"
                                className="cursor-pointer fill-actionPrimary"
                            >
                                <path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"></path>
                            </svg>
                        </div>
                    )}
                </span>
            )}
        </p>
    );
};

export default RxWhatsApp;
